export default __webpack_public_path__ + "static/media/loading.44a8f212.gif";